module.exports = __webpack_public_path__ + "image/TM_1.png";